/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { gql, useApolloClient } from '@apollo/client'
import { getAction } from '@wolfdanepug/common-react'
import { AppContext } from '../context/app/AppContext'

export const useQuery = (
	doc: string,
	variables: { [key: string]: any } = {},
	cache: any = 'network-only'
) => {
	const { updateAppState } = useContext(AppContext)
	const [loading, setLoading] = useState<boolean>(false)
	const [data, setData] = useState<any>(null)
	const [error, setError] = useState<any>(null)
	const { current: query } = useRef(doc)

	const apollo = useApolloClient()

	const fetchData = useCallback(async () => {
		setLoading(true)
		try {
			const { data } = await apollo.query({
				query: gql(query),
				variables,
				fetchPolicy: cache
			})
			setData(data[getAction(query)])
		} catch (e) {
			setError(e)
			updateAppState({ error: e })
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		fetchData()
	}, [])

	return {
		loading,
		data,
		error
	}
}
